var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _line, _line2, _line3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAdAgency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 33,
    height: 33,
    rx: 3,
    fill: "#095485"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 33,
    rx: 3,
    fill: "#106FAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3 27.4164V11.5836C3 10.1564 4.38121 9 6.08589 9H29.9141C31.6188 9 33 10.1564 33 11.5836V27.4164C33 28.8436 31.6188 30 29.9141 30H6.08589C4.38121 30 3 28.8436 3 27.4164Z",
    fill: "#34A7F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 3.07467V6H4.9236e-06V3.07467C-0.000330405 2.87697 0.0164635 2.67972 0.0501795 2.48579C0.169594 1.78532 0.499324 1.15409 0.982733 0.700489C1.46614 0.246883 2.07306 -0.000788823 2.69929 1.88745e-06H33.3007C34.0097 -6.38683e-05 34.6902 0.318153 35.1947 0.885721C35.6993 1.45329 35.9873 2.2245 35.9963 3.0323C36 3.04501 36 3.0609 36 3.07467Z",
    fill: "#177CBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53702 4.47346C5.4668 4.47346 6.22053 3.71973 6.22053 2.78995C6.22053 1.86018 5.4668 1.10645 4.53702 1.10645C3.60725 1.10645 2.85352 1.86018 2.85352 2.78995C2.85352 3.71973 3.60725 4.47346 4.53702 4.47346Z",
    fill: "#228BCE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8826 1.10645H10.6175C9.73845 1.10645 9.02588 1.81903 9.02588 2.69805V2.8809C9.02588 3.75992 9.73845 4.47252 10.6175 4.47252H29.8826C30.7616 4.47252 31.4742 3.75992 31.4742 2.8809V2.69805C31.4742 1.81903 30.7616 1.10645 29.8826 1.10645Z",
    fill: "#228BCE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.744 24.6687L20.0608 37.0592L21.1526 36.855C21.3802 36.8126 21.5845 36.6887 21.7274 36.5067C21.8703 36.3246 21.9421 36.0967 21.9292 35.8656L21.2545 23.7927L17.744 24.6687Z",
    fill: "#015A93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7764 36.9221L19.7949 37.1061C19.672 37.1292 19.5456 37.1279 19.4231 37.1021C19.3007 37.0763 19.1845 37.0266 19.0813 36.9558C18.9781 36.8851 18.8899 36.7946 18.8217 36.6896C18.7536 36.5847 18.7068 36.4673 18.6841 36.3443L16.9666 27.1599L16.5421 24.8903L20.055 24.0132L20.239 27.3832L20.7764 36.9221Z",
    fill: "#34A7F0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M20.2451 27.3862C20.0687 27.3243 19.8889 27.2725 19.7066 27.2311C18.8122 27.0286 17.8811 27.0519 16.9696 27.1611L16.5451 24.8916L20.058 24.0144L20.2451 27.3862Z",
    fill: "url(#paint0_linear_2577_14877)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2032 19.615L18.6062 22.049C18.9386 24.0566 17.6579 25.9385 15.7441 26.255L11.5178 26.9549C9.60644 27.2714 7.78773 25.903 7.45527 23.8953L7.05227 21.4614C6.71981 19.4537 8.00058 17.5718 9.91192 17.2553L14.1382 16.556C16.052 16.2389 17.8707 17.6074 18.2032 19.615Z",
    fill: "#288BCA"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.2032 19.615L18.6062 22.049C18.9386 24.0566 17.6579 25.9385 15.7441 26.255L15.1816 26.3483C13.1138 26.6905 11.1454 25.2092 10.7872 23.0433L10.4805 21.1939C10.1217 19.028 11.5074 16.9915 13.5751 16.6493L14.1376 16.556C16.052 16.2389 17.8707 17.6074 18.2032 19.615Z",
    fill: "url(#paint1_linear_2577_14877)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0285 7.01221L36.7021 29.2018L32.355 28.4927L31.1061 28.2872L14.9291 25.6496C14.1605 25.5236 13.4507 25.1601 12.8994 24.61C12.3481 24.0599 11.983 23.3509 11.8553 22.5826L11.6419 21.2945C11.6213 21.1727 11.6074 21.0498 11.6002 20.9265C11.5538 20.212 11.7143 19.4994 12.0624 18.8738C12.4105 18.2481 12.9315 17.7361 13.563 17.3988L28.5765 9.38666L29.883 8.69168L33.0285 7.01221Z",
    fill: "#34A7F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4432 22.4459C30.1056 24.5958 31.0871 26.6339 32.355 28.4922L31.1061 28.2867C30.8419 27.8708 30.5917 27.4467 30.3553 27.0145C28.6046 23.8288 27.6326 20.274 27.519 16.6408C27.4693 14.8374 27.6067 13.0144 28.0201 11.2306C28.1642 10.6041 28.3501 9.98787 28.5765 9.38613L29.883 8.69177C29.3389 9.78239 29.0083 10.9527 28.7948 12.1225C28.1655 15.5845 28.425 19.1213 29.4432 22.4459Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3216 17.5387C39.3362 23.6665 38.6112 28.8865 36.7029 29.2042C35.2393 29.4465 33.5016 26.7243 32.3171 22.6746C31.5578 20.0479 31.1098 17.341 30.9824 14.6097C30.7983 10.3945 31.5657 7.25757 33.0293 7.01528C34.9375 6.69632 37.3052 11.409 38.3216 17.5387Z",
    fill: "#015A93"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6715 14.6012L36.7578 21.1645L34.909 21.7914L32.3175 22.6704C31.5575 20.0438 31.1093 17.3369 30.9821 14.6055L33.1081 14.6012H35.6715Z",
    fill: "#DEF1FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9087 21.7931L32.3171 22.6721C31.5572 20.0455 31.1089 17.3386 30.9817 14.6072L33.1078 14.6029C33.1078 14.6084 33.1022 14.6146 33.1004 14.6201C32.3349 16.4296 32.5189 18.6072 33.569 20.2633C33.9371 20.837 34.3886 21.3526 34.9087 21.7931Z",
    fill: "#BFDFF7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1542 18.0468C34.8603 16.228 35.0812 14.6794 35.6477 14.5878C36.2141 14.4963 36.9116 15.8965 37.2056 17.7152C37.4995 19.534 37.2786 21.0826 36.7121 21.1742C36.1457 21.2657 35.4482 19.8655 35.1542 18.0468Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9105 18.4744C35.7271 17.3664 35.858 16.422 36.203 16.3649C36.5479 16.3078 36.9762 17.1596 37.1596 18.2676C37.343 19.3755 37.2121 20.32 36.8672 20.3771C36.5223 20.4342 36.094 19.5823 35.9105 18.4744Z",
    fill: "#BFDFF6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.1,
    y1: 14.3,
    x2: 43.3,
    y2: 11.9,
    stroke: "#BFDFF6",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40.4341,
    y1: 17.4418,
    x2: 47.4418,
    y2: 16.5659,
    stroke: "#BFDFF6",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40.5883,
    y1: 20.6078,
    x2: 44.6078,
    y2: 21.4117,
    stroke: "#BFDFF6",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2577_14877",
    x1: 18.3961,
    y1: 31.9291,
    x2: 17.8723,
    y2: 23.1277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8077BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2577_14877",
    x1: 1.34559,
    y1: 18.3472,
    x2: 17.8383,
    y2: 21.5508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015A93"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAdAgency);
export default __webpack_public_path__ + "static/media/logo_ad_agency.01630822d1b7c1dcc92016e619c1b146.svg";
export { ForwardRef as ReactComponent };